const q = require('queried');
const delegate = require('emmy/delegate');
const serialize = require('form-serialize');
const ajax = require('component-ajax');
const _ = require('./i18n');

const feedbackFormHendler = () => delegate(document.body, 'submit', '.contactForm-fields', (e) => {
  const form = e.delegateTarget;
  const data = serialize(form, { hash: true });

  e.preventDefault();

  ajax({
    data,
    type: form.method,
    url: form.action,
    success: () => {
      const text = _('Your message was successfully sent!');
      form.innerHTML = `<div class="contactForm-success">${text}</div>`;
    },
    error: (responseData) => {
      const response = JSON.parse(responseData.response);
      if (response && response['g-recaptcha-response']) {
        const warningEl = document.createElement('div');
        warningEl.classList.add('contactForm-error', 'errorlist');
        warningEl.innerHTML = `<span>${response['g-recaptcha-response']}</span>`;
        q('.g-recaptcha', form).appendChild(warningEl);
      }
    },
  });
});

module.exports = feedbackFormHendler;
